export default __webpack_public_path__ + "static/media/angpao-cn.667f57ad.webp";